import React from 'react';
import { Dialog, T } from '@colonist/ui';
import { PatchNotesContent } from '../PatchNotesContent/PatchNotesContent.tsx';
export function PatchNotesDialog({ open, onClose, patchNotes, announcements, onExternalClick, onProfileClick }) {
    var _patchNotes_;
    const title = {
        key: 'strings:popups.patchNote.newUpdate',
        options: {
            version: (_patchNotes_ = patchNotes[0]) === null || _patchNotes_ === void 0 ? void 0 : _patchNotes_.version
        }
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        size: "lg"
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement(T, {
        id: title
    })), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement(PatchNotesContent, {
        patchNotes: patchNotes,
        announcements: announcements,
        onExternalClick: onExternalClick,
        onProfileClick: onProfileClick
    })));
}
